<div class="container">
  <div class="row">
    <div class="col-6">
      <h1>Editar Paciente</h1>
    </div>
  </div>
</div>
<paciente-registro [cModal]=true [id_paciente]="id_paciente"></paciente-registro>
